import { Notification } from '@thanx/uikit/notification'
import { Switch } from '@thanx/uikit/switch'
import { Button } from 'react-bootstrap'

import FlagIcon from 'components/FlagIcon'
import Spinner from 'components/Spinner'
import useProducts from 'hooks/useProducts'
import { useShowMore } from 'hooks/useShowMore'
import { buildTranslate } from 'locales'
import ProductItem from './Item'

const t = buildTranslate('redeem_manager.detail.cards.online_redemption')

type ProductListProps = {
  productIds: string[]
}

const ProductList = ({ productIds }: ProductListProps) => {
  const { products, isLoading, shouldDisplayIds } = useProducts()
  const {
    visibleItems: visibleProductIds,
    hiddenCount,
    hasHidableItems,
    toggleShowAll,
    showAll,
  } = useShowMore(productIds)

  if (isLoading) {
    return <Spinner isLoading className="text-center margin-top-huge" />
  }

  const anyFound = productIds.some(
    productId => !!products.find(product => product.chain_uid === productId)
  )

  return (
    <div>
      <Switch
        condition={!shouldDisplayIds && anyFound}
        fallback={
          <>
            <p>{productIds.join(', ')}</p>
            <Notification kind="warning" size="full">
              <FlagIcon color="#e7b41a" />
              <span className="ml-xs body-text-4">
                {t('items_not_available')}
              </span>
            </Notification>
          </>
        }
      >
        {visibleProductIds.map(id => {
          const product = products.find(p => p.chain_uid === id)
          if (!product) return null
          return <ProductItem key={product.chain_uid} product={product} />
        })}
        <Switch condition={hasHidableItems}>
          <Button bsStyle="link" type="button" onClick={toggleShowAll}>
            {showAll ? t('show_less') : t('show_more', { count: hiddenCount })}
          </Button>
        </Switch>
      </Switch>
    </div>
  )
}

export default ProductList
